import axios from "axios";
import Config from "../../../config/index";

import { CREATE_PACKAGING_FAILURE, CREATE_PACKAGING_REQUEST, CREATE_PACKAGING_SUCCESS, EDIT_PACKAGING_FAILURE, EDIT_PACKAGING_REQUEST, EDIT_PACKAGING_SUCCESS, GET_DELETE_PACKAGING_FAILURE, GET_DELETE_PACKAGING_REQUEST, GET_DELETE_PACKAGING_SUCCESS, GET_PACKAGING_FAILURE, GET_PACKAGING_REQUEST, GET_PACKAGING_SUCCESS, UPLOAD_FG_FAILURE, UPLOAD_FG_REQUEST, UPLOAD_FG_SUCCESS, UPLOAD_PACKAGING_FAILURE, UPLOAD_PACKAGING_REQUEST, UPLOAD_PACKAGING_SUCCESS } from "./packagingTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getPackagingRequest = () => {
  return {
    type: GET_PACKAGING_REQUEST,
  };
};

const getPackagingSuccess = (payload) => {
  return {
    type: GET_PACKAGING_SUCCESS,
    payload: payload,
  };
};

const getPackagingFailure = (error) => {
  return {
    type: GET_PACKAGING_FAILURE,
    payload: error,
  };
};

const getPackaging = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getPackagingRequest());

    let url;

    // If dppId is provided → call /get_dpp?dppId=...
    if (dppId) {
      url = `${baseUrl}/dpp/v1/packaging_waste_management/get_dpp?dppId=${dppId}`;
    } else {
      // If dppId is not provided → call base endpoint without /get_dpp
      url = `${baseUrl}/dpp/v1/packaging_waste_management/get_all`;
    }

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPackagingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPackagingFailure(err.message));
      });
  };
};


const deletePackagingRequest = () => {
  return {
    type: GET_DELETE_PACKAGING_REQUEST,
  };
};

const deletePackagingSuccess = (payload) => {
  return {
    type: GET_DELETE_PACKAGING_SUCCESS,
    payload: payload,
  };
};

const deletePackagingFaliure = (error) => {
  return {
    type: GET_DELETE_PACKAGING_FAILURE,
    payload: error,
  };
};

const deletePackaging = (pkgId,userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(deletePackagingRequest());
    // let url = `${baseUrl}/dpp/product_passport/delete?pkgId=${pkgId}`;
    let url = `${baseUrl}/dpp/packaging_waste_management/delete?pkgId=${pkgId}&userId=${userId}`;
    // let url = `${baseUrl}/mvtmap?id=${productId}`;
    // let url = `/mvtmap?id=334`;
    return axios
      .delete(url, {}, headers)
      .then((response) => {
        dispatch(deletePackagingSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deletePackagingFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const createPackagingRequest = () => {
  return {
    type: CREATE_PACKAGING_REQUEST,
  };
};

const createPackagingSuccess = (payload) => {
  return {
    type: CREATE_PACKAGING_SUCCESS,
    payload: payload,
  };
};

const createPackagingFailure = (error) => {
  return {
    type: CREATE_PACKAGING_FAILURE,
    payload: error,
  };
};

const createPackaging = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createPackagingRequest());
    let url = `${baseUrl}/dpp/v1/packaging_waste_management/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createPackagingSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createPackagingFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const editPackagingRequest = () => {
  return {
    type: EDIT_PACKAGING_REQUEST,
  };
};

const editPackagingSuccess = (payload) => {
  return {
    type: EDIT_PACKAGING_SUCCESS,
    payload: payload,
  };
};

const editPackagingFailure = (error) => {
  return {
    type: EDIT_PACKAGING_FAILURE,
    payload: error,
  };
};
const editPackaging = (payload, jwtToken) => {
  const headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(editPackagingRequest());

    const url = `${baseUrl}/dpp/v1/packaging_waste_management/update`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(editPackagingSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editPackagingFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export default editPackaging;

const uploadForPackagingRequest = () => {
  return {
    type: UPLOAD_PACKAGING_REQUEST,
  };
};

const uploadForPackagingSuccess = (payload) => {
  return {
    type: UPLOAD_PACKAGING_SUCCESS,
    payload: payload,
  };
};

const uploadForPackagingFailure = (error) => {
  return {
    type: UPLOAD_PACKAGING_FAILURE,
    payload: error,
  };
};

const uploadForPackaging = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForPackagingRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_packaging/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForPackagingSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForPackagingFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const uploadForProductionRequest = () => {
  return {
    type: UPLOAD_FG_REQUEST,
  };
};

const uploadForProductionSuccess = (payload) => {
  return {
    type: UPLOAD_FG_SUCCESS,
    payload: payload,
  };
};

const uploadForProductionFailure = (error) => {
  return {
    type: UPLOAD_FG_FAILURE,
    payload: error,
  };
};

const uploadForProduction = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadForProductionRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_production/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadForProductionSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadForProductionFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};




export {
  getPackaging,
  deletePackaging,
  createPackaging,
  editPackaging,
  uploadForPackaging,
  uploadForProduction
  //  getDocumentTypeWithPagination
  //  , createDocumentType
};
